// Admin Street detail page: shows the street's StreetGeometry polyline (if
// any) with draggable vertices, and a draw toolbar to add/remove segments -
// a manual override for whatever StreetGeocodingWorker/StreetSyncWorker
// (Photon+OSRM) got wrong or couldn't resolve at all. See
// Admin::StreetsController#update_geometry for the save endpoint.
import L from "leaflet";
import "@geoman-io/leaflet-geoman-free";
import "@geoman-io/leaflet-geoman-free/dist/leaflet-geoman.css";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

function showStatus(el, message, isError) {
  el.textContent = message;
  el.className = isError ? "mt-2 text-danger" : "mt-2 text-success";
}

function initializeStreetGeometryMap() {
  const container = document.querySelector("[data-street-geometry-map]");
  if (!container) return;

  const coordinates = JSON.parse(
    container.getAttribute("data-coordinates") || "[]",
  );
  const centerLat = parseFloat(container.getAttribute("data-center-lat"));
  const centerLon = parseFloat(container.getAttribute("data-center-lon"));
  const saveUrl = container.getAttribute("data-save-url");
  const statusEl = document.getElementById("street-geometry-status");
  const saveButton = document.getElementById("street-geometry-save");

  const map = L.map(container);

  L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
    attribution:
      '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    maxZoom: 19,
  }).addTo(map);

  const bounds = [];
  coordinates.forEach(function (segment) {
    const polyline = L.polyline(segment, { color: "#0d6efd", weight: 5 }).addTo(
      map,
    );
    polyline.pm.enable({ allowSelfIntersection: true });
    segment.forEach(function (point) {
      bounds.push(point);
    });
  });

  if (bounds.length > 0) {
    map.fitBounds(bounds, { padding: [20, 20] });
  } else if (!Number.isNaN(centerLat) && !Number.isNaN(centerLon)) {
    map.setView([centerLat, centerLon], 13);
  } else {
    map.setView([0, 0], 2);
  }

  map.pm.addControls({
    position: "topleft",
    drawMarker: false,
    drawCircleMarker: false,
    drawCircle: false,
    drawRectangle: false,
    drawPolygon: false,
    drawText: false,
    drawPolyline: true,
    editMode: true,
    dragMode: true,
    removalMode: true,
  });

  map.on("pm:create", function (e) {
    if (e.shape === "Line") {
      e.layer.pm.enable({ allowSelfIntersection: true });
    }
  });

  if (!saveButton) return;

  saveButton.addEventListener("click", function () {
    const segments = [];
    map.pm.getGeomanLayers().forEach(function (layer) {
      if (layer instanceof L.Polyline && !(layer instanceof L.Polygon)) {
        segments.push(
          layer.getLatLngs().map(function (point) {
            return [point.lat, point.lng];
          }),
        );
      }
    });

    const csrfToken = document
      .querySelector('meta[name="csrf-token"]')
      ?.getAttribute("content");

    saveButton.disabled = true;
    fetch(saveUrl, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-CSRF-Token": csrfToken,
      },
      body: JSON.stringify({ coordinates: segments }),
    })
      .then(function (r) {
        return r.json().then(function (data) {
          return { ok: r.ok, data: data };
        });
      })
      .then(function ({ ok, data }) {
        saveButton.disabled = false;
        if (ok && data.success) {
          showStatus(statusEl, "Геометрію збережено.", false);
        } else {
          showStatus(
            statusEl,
            "Помилка: " + (data.error || "не вдалося зберегти"),
            true,
          );
        }
      })
      .catch(function () {
        saveButton.disabled = false;
        showStatus(statusEl, "Помилка з'єднання з сервером.", true);
      });
  });
}

document.addEventListener("turbo:load", initializeStreetGeometryMap);
document.addEventListener("turbolinks:load", initializeStreetGeometryMap);
document.addEventListener("DOMContentLoaded", initializeStreetGeometryMap);
